import { render, staticRenderFns } from "./thumnails-details.component.vue?vue&type=template&id=7660dcb2"
import script from "./thumnails-details.component.vue?vue&type=script&lang=js"
export * from "./thumnails-details.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports